module.exports = __webpack_public_path__ + "static/media/1006576.02e1a89d.png";